import { render } from "./VendaOrdensProducaoVinculadasTab.vue?vue&type=template&id=c838d6ec&scoped=true&ts=true"
import script from "./VendaOrdensProducaoVinculadasTab.vue?vue&type=script&lang=ts"
export * from "./VendaOrdensProducaoVinculadasTab.vue?vue&type=script&lang=ts"

import "./VendaOrdensProducaoVinculadasTab.vue?vue&type=style&index=0&id=c838d6ec&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c838d6ec"]])

export default __exports__